"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listBuilder = exports.validateUsername = exports.validatePassword = exports.validateEmail = exports.validateRequired = exports.isAllValid = exports.ValidateState = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var validator_1 = __importDefault(require("validator"));
var numbers_1 = require("./constants/numbers");
var ValidateState;
(function (ValidateState) {
    ValidateState["required"] = "required";
    ValidateState["minLength"] = "minLength";
    ValidateState["invalidEmail"] = "invalidEmail";
    ValidateState["validated"] = "validated";
})(ValidateState = exports.ValidateState || (exports.ValidateState = {}));
var isAllValid = function (errorObj) {
    var notValid = Object.values(errorObj).find(function (ea) { return ea !== ValidateState.validated; });
    return !notValid;
};
exports.isAllValid = isAllValid;
var validateRequired = function (str) {
    if (str.length === 0) {
        // string is empty
        return false;
    }
    // string passed required validation
    return true;
};
exports.validateRequired = validateRequired;
var validateEmail = function (email) {
    if (!exports.validateRequired(email)) {
        // if empty
        return ValidateState.required;
    }
    if (!validator_1.default.isEmail(email)) {
        return ValidateState.invalidEmail;
    }
    return ValidateState.validated;
};
exports.validateEmail = validateEmail;
var validatePassword = function (password) {
    if (!exports.validateRequired(password)) {
        // if empty
        return ValidateState.required;
    }
    if (password.length < numbers_1.MIN_PASSWORD_LENGTH) {
        // min length
        return ValidateState.minLength;
    }
    return ValidateState.validated;
};
exports.validatePassword = validatePassword;
var validateUsername = function (username) {
    if (!exports.validateRequired(username)) {
        // if empty
        return ValidateState.required;
    }
    if (username.length < numbers_1.MIN_USERNAME_ROOM_LENGTH) {
        // min length
        return ValidateState.minLength;
    }
    return ValidateState.validated;
};
exports.validateUsername = validateUsername;
var listBuilder = function (_a) {
    var errors = _a.errors;
    var objKeys = Object.keys(errors);
    if (objKeys.length)
        return (jsx_runtime_1.jsx("ul", { children: Object.values(errors).map(function (ea, ind) {
                return jsx_runtime_1.jsx("li", { children: ea.message }, ind);
            }) }, void 0));
    return null;
};
exports.listBuilder = listBuilder;
//# sourceMappingURL=validations.js.map